import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from 'pages/Home/Home.tsx';
import UserStatusHandler from 'components/UserStatusHandler';
import NotFound from '../NotFound/NotFound';

const Router = () => (
  <Routes>
    <Route
      exact
      path="/"
      element={
        <UserStatusHandler>
          <Home />
        </UserStatusHandler>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default Router;
